import '@polymer/polymer/polymer-legacy.js';
import '@polymer/iron-meta/iron-meta.js';
import '@polymer/iron-icons/av-icons.js';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/iron-icons/device-icons.js';
import '@polymer/iron-icons/editor-icons.js';
import '@polymer/iron-icons/hardware-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/maps-icons.js';
import '@polymer/iron-icons/notification-icons.js';
import '@polymer/iron-icons/places-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '../katapult-map-icons/katapult-map-icons.js';
import { GeoStyleToIcon, ListenForExternalIconLoaded } from '../../modules/GeoStyleToIcon.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import 'firebase/compat/firestore';
import { GeoFire } from 'geofire';
import { KatapultGeometry } from 'katapult-toolbox';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { ToTitleCase } from '../../modules/ToTitleCase.js';
import { Round } from '../../modules/Round.js';
import { Throttle } from '../../modules/Throttle.js';
import { FormatHeight } from '../../modules/FormatHeight.js';
import { GeofireTools } from '../../modules/GeofireTools.js';
import { Path } from '../../modules/Path.js';
import { HybridMarker } from './HybridMarker.js';
/* global Polymer, k, firebase, google, GeoFire */
Polymer({
  _template: html`
    <style>
      #ruler {
        visibility: hidden;
        white-space: pre;
        position: absolute;
        z-index: -1;
        font-size: 8pt;
        font-family: Helvetica;
      }
    </style>
    <katapult-map-icons model-key="[[jobCreator]]"></katapult-map-icons>
    <iron-meta id="meta" type="iconset"></iron-meta>
    <span id="ruler"></span>
  `,

  is: 'load-render-map',

  properties: {
    // clusterMaxZoom:{
    //   type:Number,
    //   value:15,
    //   notify:true,
    //   observer:'clusterMaxZoomChanged'
    // },
    clickableConnections: {
      type: Boolean,
      value: true,
      observer: 'clickableConnectionsChanged'
    },
    clickableNodes: {
      type: Boolean,
      value: true,
      observer: 'clickableNodesChanged'
    },
    draggable: {
      type: Boolean,
      value: false
    },
    hidden: {
      type: Boolean,
      value: false
    },
    cableTracing: {
      type: Boolean,
      value: false
    },
    connectionTracing: {
      type: Boolean,
      value: false
    },
    pointCount: {
      type: Number,
      value: 0
    },
    shrinkDoneItems: {
      type: Boolean,
      value: false
    },
    layers: {
      type: Object
    },
    mainJobId: String,
    labeledAttributes: Object,
    hiddenMarkers: Object,
    hiddenNodes: {
      type: Array,
      value: () => []
    },
    hiddenConnections: {
      type: Array,
      value: () => []
    },
    map: Object,
    mapIsReady: {
      type: Boolean,
      observer: 'setupQuery'
    },
    pointLocations: {
      type: Object,
      value: () => ({})
    },
    projection: {
      type: Object,
      notify: true
    },
    lineLocations: {
      type: Object,
      value: () => ({})
    },
    annotationLocations: {
      type: Object,
      value: () => ({})
    },
    sectionList: {
      type: Object,
      value: () => ({})
    },
    connsToLabel: {
      type: Array,
      value: () => []
    },
    pointEvents: {
      type: Object,
      value: () => ({
        click: {
          s: 'section-click',
          n: 'node-click'
        },
        dblclick: {
          s: 'section-dbl-click',
          n: 'node-dbl-click',
          a: 'annotation-dbl-click'
        },
        drag: {
          s: 'section-drag',
          n: 'node-drag',
          a: 'annotation-drag'
        },
        dragstart: {
          s: 'section-drag-start',
          n: 'node-drag-start'
        },
        dragend: {
          s: 'section-drag-end',
          n: 'node-drag-end'
        },
        mouseover: {
          a: 'annotation-mouseover',
          n: 'node-mouseover'
        },
        mouseout: {
          a: 'annotation-mouseout',
          n: 'node-mouseout'
        }
      })
    },
    localStyles: {
      type: Object
    },
    useMetricUnits: {
      type: Boolean,
      observer: 'useMetricChanged'
    },
    showAnglesOfNode: {
      type: String,
      observer: 'showConnAngles'
    },
    showSpanDistances: {
      type: Boolean,
      value: false,
      observer: 'updateAllConnLabels'
    },
    zoomToItem: {
      type: String,
      observer: 'zoomToItemChanged'
    },
    otherAttributes: {
      type: Object
    },
    enabledFeatures: {
      type: Object,
      value: () => ({})
    }
  },

  observers: [
    'layersChanged(layers.*)',
    'updateLabelListeners(labeledAttributes.*)',
    'labelFontSizeChanged(labelFontSize)',
    'hideShowMarkers(hiddenMarkers.*, hiddenNodes.*, hiddenConnections.*)',
    'showCableTracing(cableTracing)',
    'showConnectionTracing(connectionTracing)',
    'localStyleChangedHandler(localStyle)',
    'updateDraggable(draggable)',
    'mapVisibilityChanged(hidden)'
  ],

  created: function () {
    this.geo = {};
    this.labelListenerQueue = [];
    this.labelListenerQueueDelay = 50;
    this.labelListenerQueueTimeout = null;
    // Set up the update function for geoQuery to be throttled
    this.updateGeoQuery = Throttle(() => {
      // Check that we have a map object and bounds are accessible
      if (this.map && this.map.getBounds()) {
        if (!this.projection) {
          this.projection = this.map.getProjection();
        }
        let zoom = this.map.getZoom();
        for (const jobId in this.geo) {
          let boundsRadius = this.getRadiusFromBounds();
          const jobLayer = this.layers[jobId];
          const jobGeoRef = this.geo[jobId];
          if (!jobLayer || (jobLayer.minZoom != null && zoom < jobLayer.minZoom)) {
            jobGeoRef.geoQuery?.cancel();
            delete jobGeoRef.geoQuery;
            this.removeJobFromMap(jobId);
          } else {
            // We don't disable geofire for layers starting with '__ref' because they SHOULD be geo-queried on account of their size.
            const jobIsReferenceLayer = jobId.startsWith('__ref');
            const jobShouldBypassGeoQuery = !jobIsReferenceLayer;

            // Respect maxRadius if it is set, otherwise bypass geoQuery if permissible.
            if (jobLayer.maxRadius) boundsRadius.radius = jobLayer.maxRadius / 1000;
            else if (jobShouldBypassGeoQuery) boundsRadius.radius = Infinity;

            const radius = jobLayer.customRadius || boundsRadius;
            if (jobGeoRef.geoQuery) {
              if (!jobLayer.customRadius) {
                this.setLoading(jobId, true);
                jobGeoRef.geoQuery.updateCriteria(radius);
              }
            } else {
              this.setLoading(jobId, true);
              jobGeoRef.geoQuery = jobGeoRef.geoFire.query(radius);
              jobGeoRef.geoQuery.on('ready', () => this.setLoading(jobId, false));
              jobGeoRef.geoQuery.on('key_entered', (...args) => this.keyEntered(jobId, ...args));
              jobGeoRef.geoQuery.on('key_exited', (...args) => this.keyExited(jobId, ...args));
              if (!jobLayer.ignoreUpdates) {
                jobGeoRef.geoQuery.on('key_moved', (...args) => this.keyMoved(jobId, ...args));
              }
            }
          }
        }
      }
    }, 750);
  },

  attached: function () {
    this.keydownHandler = (e) => {
      this.ctrlDown = e.ctrlKey;
      this.metaDown = e.metaKey;
      this.shiftDown = e.shiftKey;
      this.altDown = e.altKey;
    };

    this.keyupHandler = (e) => {
      this.ctrlDown = e.ctrlKey;
      this.metaDown = e.metaKey;
      this.shiftDown = e.shiftKey;
      this.altDown = e.altKey;
    };

    document.addEventListener('keydown', this.keydownHandler);
    document.addEventListener('keyup', this.keyupHandler);

    this._detachExternalIconLoadedCallback = ListenForExternalIconLoaded(() => {
      this.localStyleChanged();
    });
  },

  detached: function () {
    document.removeEventListener('keydown', this.keydownHandler);
    document.removeEventListener('keyup', this.keyupHandler);
    this._detachExternalIconLoadedCallback?.();
    this.stopLabelListenerQueue();
  },

  ready: function () {
    if (!window.loadRenderMap) window.loadRenderMap = this;
  },

  setupTextOverlay: function () {
    if (this.TxtOverlay) return;
    function TxtOverlay(options) {
      for (let key in options) {
        this[key] = options[key];
      }
      this.setPosition();
      this.setMap(options.map);
    }
    TxtOverlay.prototype = new google.maps.OverlayView();
    TxtOverlay.prototype.setPosition = function (data) {
      if (data) this.data = data;
      let corners = loadRenderMap.getTextOverlayCorners(this.data);
      this.topLeft = corners[0];
      this.topRight = corners[1];
      this.bottomRight = corners[2];
      this.bottomLeft = corners[3];
      if (data) this.draw();
    };
    TxtOverlay.prototype.setOptions = function (data) {
      if (data) this.data = data;
      if (this.div) {
        // Check if the item is a shape or a regular rectangle
        if (this.data.backgroundShape) {
          let iconContent = loadRenderMap.getBackgroundShape(this.data.backgroundShape, {
            stroke: this.data.stroke,
            strokeWidth: this.data.strokeWidth,
            fill: this.data.fill
          });
          // Set the svg data in the div
          this.div.innerHTML = `
            <svg viewBox="0 0 24 24" focusable="false" style="position:absolute; z-index:-1; pointer-events: none; display: block; width: 100%; height: 100%;">
              ${iconContent}
            </svg>
            <span style="margin:auto; text-align:center;">${this.data.text}</span>
          `;
          // Remove styles from the rectangle version
          this.div.style.backgroundColor = null;
          this.div.style.border = null;
          this.div.style.borderRadius = null;
        } else {
          this.div.innerHTML = this.data.text;
          this.div.style.whiteSpace = 'pre';
          this.div.style.backgroundColor = this.data.fill;
          this.div.style.border = this.data.strokeWidth + 'px solid ' + this.data.stroke;
          this.div.style.borderRadius = this.data.borderRadius + 'px';
        }

        // Styles that apply to all cases
        this.div.style.display = 'flex';
        this.div.style.color = this.data.fontColor;
        this.div.style.position = 'absolute';
        this.div.style.transform = `rotate(${this.data.rotation}deg)`;
        this.div.style.transformOrigin = '0 0';
        this.div.style.zIndex = this.draggingZIndex || this.zIndex;

        if (this.fontFamily) this.div.style.fontFamily = this.fontFamily;
      }
    };
    TxtOverlay.prototype.setClickable = function (clickable) {
      this.clickable = clickable;
    };
    TxtOverlay.prototype.setDraggable = function (draggable) {
      this.draggable = draggable;
    };
    TxtOverlay.prototype.onAdd = function () {
      var div = document.createElement('DIV');
      this.div = div;
      this.setOptions();
      var panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(div);

      //// Make it draggable
      div.draggable = true;
      let that = this;
      google.maps.event.addDomListener(div, 'mousedown', function (e) {
        // make sure we only listen to the left mouse button
        if (that.draggable && e.button == 0) {
          that.oldZindex = div.style.zIndex;
          that.draggingZIndex = 100000;
          div.style.zIndex = that.draggingZIndex;
          that.map.set('draggable', false);
          that.set('origin', e);
          google.maps.event.trigger(that, 'dragstart');

          that.moveHandler = google.maps.event.addDomListener(that.get('map').getDiv(), 'mousemove', function (e) {
            let origin = that.get('origin');
            let left = origin.clientX - e.clientX;
            let top = origin.clientY - e.clientY;
            let projection = that.getProjection();
            if (projection) {
              let pos = projection.fromLatLngToDivPixel(new google.maps.LatLng(that.data.origin[0], that.data.origin[1]));
              let latLng = projection.fromDivPixelToLatLng(new google.maps.Point(pos.x - left, pos.y - top));
              that.set('origin', e);
              that.data.origin = [latLng.lat(), latLng.lng()];
              that.setPosition(that.data);
              google.maps.event.trigger(that, 'drag', { latLng });
            } else {
              google.maps.event.trigger(div, 'mouseup');
            }
          });

          that.leaveHandler = google.maps.event.addDomListener(that.get('map').getDiv(), 'mouseleave', function () {
            google.maps.event.trigger(div, 'mouseup');
          });

          that.upHandler = google.maps.event.addDomListener(that.get('map').getDiv(), 'mouseup', function () {
            google.maps.event.trigger(div, 'mouseup');
          });
        }
      });

      google.maps.event.addDomListener(div, 'mouseup', function () {
        loadRenderMap.map.set('draggable', true);
        that.draggingZIndex = that.oldZindex;
        div.style.zIndex = that.draggingZIndex;
        google.maps.event.removeListener(that.moveHandler);
        google.maps.event.removeListener(that.leaveHandler);
        google.maps.event.removeListener(that.upHandler);
        google.maps.event.trigger(that, 'dragend');
      });
      ///// End Make it draggable

      for (var eventName in loadRenderMap.pointEvents) {
        if (loadRenderMap.pointEvents[eventName].a) {
          google.maps.event.addDomListener(
            div,
            eventName,
            function (eventName, e) {
              if (eventName != 'click' || this.clickable) {
                google.maps.event.trigger(this, eventName, e);
              }
            }.bind(this, eventName)
          );
        }
      }
    };
    TxtOverlay.prototype.draw = function () {
      if (this.div) {
        let overlayProjection = this.getProjection();

        // Calculate Font Size
        let fontFeet = (this.data.fontSize * this.data.feetPerInch) / 72; // fontSize is in pt. 72pt = 1" and scale is value of data.feetPerInch so fontFeet = (fontPt * 1"/72pt * data.feetPerInch)
        let fontBottomLL = google.maps.geometry.spherical.computeOffset(this.topLeft, fontFeet * 0.3048, 180);
        let fontTop = overlayProjection.fromLatLngToDivPixel(this.topLeft);
        let fontBottom = overlayProjection.fromLatLngToDivPixel(fontBottomLL);
        let fontSize = Math.abs(fontTop.y - fontBottom.y) + 'px';
        this.div.style.fontSize = fontSize;
        // End Calculate Font Size

        let tL = overlayProjection.fromLatLngToDivPixel(this.topLeft);
        let tR = overlayProjection.fromLatLngToDivPixel(this.topRight);
        let bR = overlayProjection.fromLatLngToDivPixel(this.bottomRight);
        this.div.style.left = tL.x + 'px';
        this.div.style.top = tL.y + 'px';

        // If the background should be a shape, then for now assume that
        // it will be square and set the width and height to the biggest value
        if (this.data.backgroundShape) {
          // Multiple by 1.15 to give some buffer space
          this.div.style.width = this.div.style.height =
            Math.max(KatapultGeometry.CalcDistanceXY(tL, tR), KatapultGeometry.CalcDistanceXY(tR, bR)) * 1.5 + 'px';
        } else {
          // Otherwise, set the sizes the old way
          this.div.style.width = KatapultGeometry.CalcDistanceXY(tL, tR) + 'px';
          this.div.style.height = KatapultGeometry.CalcDistanceXY(tR, bR) + 'px';
        }
      }
    };
    TxtOverlay.prototype.onRemove = function () {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    };
    this.TxtOverlay = TxtOverlay;
  },

  getTextOverlayCorners: function (data) {
    // TOP_LEFT TOP_RIGHT CENTER BOTTOM_LEFT BOTTOM_RIGHT
    let originLL = new google.maps.LatLng(data.origin[0], data.origin[1]);
    let width = 0;
    let height = 0;
    let widthHeading = 90 + data.rotation;
    let heightHeading = 180 + data.rotation;
    width = data.width * 0.3048;
    height = data.height * 0.3048;

    // Force TOP_LEFT if not TOP_CENTER.
    if (!['TOP_CENTER', 'CENTER'].includes(data.anchor)) data.anchor = 'TOP_LEFT';
    // Position box according to anchor point.
    let topLeft, topRight, bottomLeft, bottomRight;
    if (data.anchor === 'TOP_LEFT') {
      topLeft = originLL;
      topRight = google.maps.geometry.spherical.computeOffset(originLL, width, widthHeading);
      bottomRight = google.maps.geometry.spherical.computeOffset(topRight, height, heightHeading);
      bottomLeft = google.maps.geometry.spherical.computeOffset(originLL, height, heightHeading);
    } else if (data.anchor === 'TOP_CENTER') {
      topLeft = google.maps.geometry.spherical.computeOffset(originLL, -width / 2, widthHeading);
      topRight = google.maps.geometry.spherical.computeOffset(originLL, width / 2, widthHeading);
      bottomRight = google.maps.geometry.spherical.computeOffset(topRight, height, heightHeading);
      bottomLeft = google.maps.geometry.spherical.computeOffset(topLeft, height, heightHeading);
    } else if (data.anchor === 'CENTER') {
      const leftCenter = google.maps.geometry.spherical.computeOffset(originLL, -width / 2, widthHeading);
      topLeft = google.maps.geometry.spherical.computeOffset(leftCenter, -height / 2, heightHeading);
      topRight = google.maps.geometry.spherical.computeOffset(topLeft, width, widthHeading);
      bottomRight = google.maps.geometry.spherical.computeOffset(topRight, height, heightHeading);
      bottomLeft = google.maps.geometry.spherical.computeOffset(topLeft, height, heightHeading);
    }
    return [topLeft, topRight, bottomRight, bottomLeft];
  },

  layersChanged: function () {
    this.resetMap();
    for (var jobId in this.layers) {
      if (this.layers[jobId] == null) {
        delete this.layers[jobId];
      }
      // Ignore API Layers since they are managed in api-map-layer
      else if (this.layers[jobId].type == 'API Layer') {
        continue;
      } else if (this.geo[jobId] == null) {
        if (this.layers[jobId].url == null && jobId[0] == '-') {
          this.set('layers.' + jobId + '.url', 'photoheight/jobs/' + jobId + '/geohash');
        }
        let database = undefined;
        if (this.layers[jobId].database) {
          database = `https://${this.layers[jobId].database}.firebaseio.com`;
        }
        if (jobId.startsWith('__refMasterLocationDirectory')) {
          // The directory id appears after the :
          let directoryId = jobId.split(':')[1];
          if (directoryId) {
            this.geo[jobId] = {
              geoFire: new GeoFire(firebase.firestore().collection(this.layers[jobId].url)),
              clickable: this.layers[jobId].clickable
            };
          }
        } else if (this.layers[jobId].firestore) {
          // Setup the default query as a base collection reference
          const layerUrl = this.layers[jobId].url;
          const defaultQuery = layerUrl ? firebase.firestore().collection(layerUrl) : null;

          // Use the query passed in or the default query
          const layerQuery = this.layers[jobId].query ?? defaultQuery;
          if (!layerQuery) continue;

          // Add the geofire call to the geo object
          this.geo[jobId] = {
            geoFire: new GeoFire(layerQuery),
            clickable: this.layers[jobId].clickable
          };
        } else {
          this.geo[jobId] = {
            geoFire: new GeoFire(FirebaseWorker.database(database).ref(this.layers[jobId].url)),
            clickable: this.layers[jobId].clickable
          };
        }
      } else if (this.layers[jobId].clickable != this.geo[jobId].clickable) {
        this.geo[jobId].clickable = this.layers[jobId].clickable;
        for (let key in this.annotationLocations) {
          if (this.annotationLocations[key].jobId == jobId) {
            this.annotationLocations[key].setClickable(this.geo[jobId].clickable);
            this.annotationLocations[key].setDraggable(
              this.geo[jobId].clickable && this.annotationLocations[key].data?.leader?.type != 'angle'
            );
          }
        }
      }
    }
    this.setupQuery();
  },

  resetMap: function () {
    for (var jobId in this.geo) {
      if (SquashNulls(this.layers, jobId) == '') {
        if (this.geo[jobId].geoQuery) {
          this.geo[jobId].geoQuery.cancel();
        }
        delete this.geo[jobId];
      }
    }
    for (var key in this.pointLocations) {
      const point = this.pointLocations[key];
      if (SquashNulls(this.layers, point.jobId) == '') {
        point.map = null;
        google.maps.event.clearInstanceListeners(point);
        if (point.labelMarker) {
          point.labelMarker.map = null;
          google.maps.event.clearInstanceListeners(point.labelMarker);
        }
        if (point.geometry) point.geometry.setMap(null);
        this.removePointLabelListeners(key);
        delete this.pointLocations[key];
        this.pointCount--;
      } else if (point.haloColor != this.layers[point.jobId].color) {
        var data = point.data;
        point.haloColor = this.layers[point.jobId].color;
        this.applyLocalStyle(data, key, point.jobId);
        let iconData = GeoStyleToIcon(data, {
          shrinkDoneItems: this.shrinkDoneItems,
          haloColor: point.haloColor,
          hiddenItems: this.hiddenMarkers
        });
        point.icon = iconData;
      }
    }
    for (var key in this.annotationLocations) {
      if (SquashNulls(this.layers, this.annotationLocations[key].jobId) == '') {
        this.removeItem(key, this.annotationLocations[key].data.t);
      }
    }
    for (var key in this.lineLocations) {
      if (SquashNulls(this.layers, this.lineLocations[key].jobId) == '') {
        this.removeItem(key, 'c');
      } else if (this.lineLocations[key].haloColor != this.layers[this.lineLocations[key].jobId].color) {
        this.lineLocations[key].haloColor = this.layers[this.lineLocations[key].jobId].color;
        if (this.lineLocations[key].haloColor == null) {
          if (this.lineLocations[key].overlays.halo) {
            this.lineLocations[key].overlays.halo.setMap(null);
            delete this.lineLocations[key].overlays.halo;
          }
        } else {
          if (this.lineLocations[key].overlays.halo == null) {
            this.getConnHalo(this.lineLocations[key]);
          } else {
            this.lineLocations[key].overlays.halo.setOptions({ strokeColor: this.layers[this.lineLocations[key].jobId].color });
          }
        }
      }
    }
    for (var key in this.sectionList) {
      if (SquashNulls(this.layers, this.sectionList[key].jobId) == '') {
        delete this.sectionList[key];
      }
    }
    // if (this.clusterer) {
    //   this.clusterer.setMarkers(this.pointLocations, this.pointCount, true);
    //   this.clusterer.setLines(this.lineLocations);
    //   this.clusterer.shouldRedraw = true;
    //   this.clusterer.resetViewport();
    //   this.clusterer.redraw();
    // }
  },

  clickableConnectionsChanged: function () {
    for (var key in this.lineLocations) {
      let jobId = this.lineLocations[key].jobId;
      if (jobId && this.layers[jobId] && this.layers[jobId].clickable != null)
        this.lineLocations[key].set('clickable', this.layers[jobId].clickable);
      else this.lineLocations[key].set('clickable', this.clickableConnections);
    }
  },

  clickableNodesChanged: function () {
    for (var key in this.pointLocations) {
      this.pointLocations[key].gmpClickable = this.clickableNodes;
    }
  },

  updateDraggable: function () {
    for (var key in this.pointLocations) {
      const point = this.pointLocations[key];
      if (point.jobId !== this.mainJobId) continue;
      point.customDraggable = this.draggable;
    }
    // for (var key in this.lineLocations) {
    //   if (this.lineLocations[key].data.b) {
    //     this.lineLocations[key].setOptions({editable:this.draggable});
    //   }
    // }
  },

  showCableTracing: function () {
    if (this.cableTracing) {
      for (var key in this.lineLocations) {
        this.enableTraceOverlay(key, this.lineLocations[key]);
      }
    } else {
      for (var key in this.lineLocations) {
        if (this.lineLocations[key].overlays.trace) {
          this.lineLocations[key].overlays.trace.setMap(null);
          this.lineLocations[key].overlays.trace.ref.off('value', this.lineLocations[key].overlays.trace.listener);
          delete this.lineLocations[key].overlays.trace;
        }
      }
    }
  },

  showConnectionTracing: function () {
    if (this.connectionTracing) {
      for (var key in this.lineLocations) {
        this.enableTraceOverlay(key, this.lineLocations[key]);
      }
    } else {
      for (var key in this.lineLocations) {
        if (this.lineLocations[key]?.overlays?.trace) {
          this.lineLocations[key].overlays.trace.setMap(null);
          this.lineLocations[key].overlays.trace.ref.off('value', this.lineLocations[key].overlays.trace.listener);
          delete this.lineLocations[key].overlays.trace;
        }
      }
    }
  },

  setupDropOverlay: function () {
    if (window.DropOverlay && !this.dropOverlay) {
      this.dropOverlay = new DropOverlay(this.map);
    }
  },

  mapVisibilityChanged: function () {
    // If not paused, set up the queries to start listening to Firebase again
    if (!this.hidden) {
      this.setupQuery();
      return;
    }

    // If we're paused, remove the main job from the map and stop the geo query
    for (const jobId in this.geo) {
      if (this.geo?.[jobId]?.geoQuery) {
        this.geo[jobId].geoQuery.cancel();
        delete this.geo[jobId].geoQuery;
      }
      this.removeJobFromMap(jobId);
    }
  },

  setupQuery: function () {
    if (this.map && this.geo) {
      this.setupTextOverlay();
      if (!this.mapBoundsListenerSetup) {
        this.mapBoundsListenerSetup = true;
        google.maps.event.addListener(this.map, 'bounds_changed', this.updateGeoQuery.bind(this));
      }
      this.updateGeoQuery();
    }
  },

  setLoading: function (jobId, loading) {
    if (this.geo[jobId]) {
      this.geo[jobId].loading = loading;
      if (loading) {
        this.fire('loading-changed', { loading: true });
      } else {
        var loading = false;
        for (var key in this.geo) {
          if (this.geo[key].loading) {
            loading = true;
            break;
          }
        }
        if (!loading) this.fire('loading-changed', { loading: false });
      }
    }
  },

  removeJobFromMap: function (jobId) {
    for (var key in this.pointLocations) {
      if (this.pointLocations[key].jobId == jobId) {
        this.removeItem(key, this.pointLocations[key].data.t);
      }
    }
    for (var key in this.lineLocations) {
      if (this.lineLocations[key].jobId == jobId) {
        this.lineLocations[key].setMap(null);
        google.maps.event.clearInstanceListeners(this.lineLocations[key]);
        if (this.lineLocations[key].labelMarker) {
          this.lineLocations[key].labelMarker.map = null;
          google.maps.event.clearInstanceListeners(this.lineLocations[key].labelMarker);
        }
        for (var item in this.lineLocations[key].overlays) {
          this.lineLocations[key].overlays[item].setMap(null);
          if (this.lineLocations[key].overlays[item].ref) {
            this.lineLocations[key].overlays[item].ref.off('value', this.lineLocations[key].overlays[item].listener);
          }
        }
        delete this.lineLocations[key];
      }
    }
    for (var key in this.annotationLocations) {
      if (this.annotationLocations[key].jobId == jobId) {
        this.removeItem(key, this.annotationLocations[key].data.t);
      }
    }
    for (var key in this.sectionList) {
      if (this.sectionList[key].jobId == jobId) {
        delete this.sectionList[key];
      }
    }
    this.setLoading(jobId, false);
    // if (this.clusterer) {
    //   this.clusterer.setMarkers(this.pointLocations, this.pointCount, true);
    //   this.clusterer.setLines(this.lineLocations);
    // }
  },

  getRadiusFromBounds: function () {
    var center = this.map.getCenter();
    // Set the starting value for the list of possible radius values to 50 meters
    let radiusValues = [0.05];
    // Add the distance from the center of the map to the north east corner of the map (converted to kilometers)
    radiusValues.push(google.maps.geometry.spherical.computeDistanceBetween(center, this.map.getBounds().getNorthEast()) / 1000);
    // Check if there are polygon points on the map to factor into the radius
    if (this.polygonSelect && this.polygonSelect.getPath().length > 0) {
      let polygonPath = this.polygonSelect.getPath();
      // Add each point on the polygon to radiusValues
      for (let i = 0; i < polygonPath.length; i++) {
        // Add the distance from the center of the map to the polygon point to radiusValues (converted to kilometers)
        let polygonPoint = polygonPath.getAt(i);
        // Get the distance from the center of the map to the polygonPoint, plus 100 meters
        radiusValues.push(google.maps.geometry.spherical.computeDistanceBetween(center, polygonPoint) / 1000);
      }
    }
    // Set the radius to the largest of the possible radius values
    let radius = Math.max.apply(null, radiusValues);
    return {
      center: [center.lat(), center.lng()],
      radius
    };
  },

  keyEntered: function (jobId, key, location, distance, data) {
    key = SquashNulls(this.layers, jobId, 'keyPrefix') + key;
    let layerStyle = SquashNulls(this.layers, jobId, 'style');
    if (layerStyle) {
      data = Object.assign(data, layerStyle);
    }
    if (data.t == 'c') {
      var ids = key.split('~');
      var connId = ids[0];
      if (this.lineLocations[connId]) {
        this.lineLocations[connId].count++;
      } else {
        // if (!this.clusterer.minLineLength) {
        //   this.clusterer.calcMinLineLength();
        // }
        // this.clusterer.addLine(connId, this.renderConn(data, connId, parseInt(ids[1]), jobId));
        this.renderConn(data, connId, parseInt(ids[1]), jobId);
        this.addLineLabelListeners(connId, `photoheight/jobs/${jobId}/connections/${connId}/attributes/`);
      }
    } else if (data.t == 'a') {
      let annotationKey = key;
      let ids = key.split('~');
      if (ids.length == 2) {
        annotationKey = ids[0];
      } else {
        data.origin = data.l;
      }
      if (this.annotationLocations[annotationKey]) {
        this.annotationLocations[annotationKey].count++;
      } else {
        this.renderAnnotation(data, annotationKey, ids[1], jobId);
      }
    } else if (this.pointLocations[key] == null) {
      // this.clusterer.addMarker(key, this.renderPoint(data, key, jobId), true);//cluster
      this.renderPoint(data, key, jobId);
      this.pointCount++;
      // this.debounce('redraw map', function() {
      //   this.clusterer.redraw();
      // }, 16);
      var attributesUrl = 'photoheight/jobs/' + jobId;
      if (data.t == 's') {
        var ids = key.split(':');
        this.sectionList[ids[0]] = this.sectionList[ids[0]] || { sections: {}, jobId };
        this.sectionList[ids[0]].sections[ids[1]] = true;
        attributesUrl += '/connections/' + ids[0] + '/sections/' + ids[1] + '/multi_attributes/';
      } else {
        attributesUrl += '/nodes/' + key + '/attributes/';
        // Fire an event when a node enters the view
        this.fire('node-entered-view', { key });
      }
      this.addPointLabelListeners(key, attributesUrl);
    }
  },

  keyMoved: function (jobId, key, location, distance, data) {
    key = SquashNulls(this.layers, jobId, 'keyPrefix') + key;
    let layerStyle = SquashNulls(this.layers, jobId, 'style');
    if (layerStyle) {
      data = Object.assign(data, layerStyle);
    }
    let newLocation = new google.maps.LatLng(location[0], location[1]);
    if (data.t == 'c') {
      var ids = key.split('~');
      var idNumber = parseInt(ids[1]);
      var line = this.lineLocations[ids[0]];
      if (line != null && idNumber == line.idNumber) {
        line.data = data;
        var path = line.getPath();
        if (path.dontRenderChange) {
          path.dontRenderChange = false;
        } else {
          var p1 = new google.maps.LatLng(location[0], location[1]);
          var p2 = new google.maps.LatLng(data.l2[0], data.l2[1]);
          if (line.idNumber == 2) {
            var t = p1;
            p1 = p2;
            p2 = t;
          }
          var points = [p1];
          if (data.b) {
            // this.setupPolylineListeners(path, line, ids[0]);
            for (var i = 0; i < data.b.length; i++) {
              points.push(new google.maps.LatLng(data.b[i][0], data.b[i][1]));
            }
          }
          points.push(p2);
          for (var i = 0; i < points.length; i++) {
            path.dontSaveChange = true;
            if (path.getLength() <= i) {
              path.push(points[i]);
            } else {
              path.setAt(i, points[i]);
            }
          }
          // Drop any leftover points when the new path is shorter.
          while (path.getLength() > points.length) {
            path.dontSaveChange = true;
            path.removeAt(path.getLength() - 1);
          }
        }
        line.length = data.d;
        for (var item in line.overlays) {
          line.overlays[item].setPath(path);
        }
        this.applyLocalStyle(data, ids[0], jobId);
        let lineOptions = this.getConnOptions(data);
        for (var prop in line.override) {
          delete lineOptions[prop];
        }
        var endPointForAngle = null;
        if (this.pointLocations[this.showAnglesOfNode]) {
          for (var connId in this.pointLocations[this.showAnglesOfNode].data.n) {
            if (connId == ids[0]) {
              endPointForAngle = this.pointLocations[this.showAnglesOfNode].data.n[connId];
              break;
            }
          }
        }
        this.updateConnLabel(ids[0], data.d, path, endPointForAngle);
        line.setOptions(lineOptions);
      }
    } else if (data.t == 'a') {
      let annotationKey = key;
      let ids = key.split('~');
      if (ids.length == 2) {
        annotationKey = ids[0];
      } else {
        data.origin = data.l;
      }
      if (this.annotationLocations[annotationKey] != null && this.annotationLocations[annotationKey].idNumber == ids[1]) {
        this.annotationLocations[annotationKey].setPosition(data);
        this.annotationLocations[annotationKey].setOptions(data);
        if (data.leader) {
          if (!this.annotationLocations[annotationKey].leader) {
            this.setupAnnotationLeader(this.annotationLocations[annotationKey], annotationKey);
          } else {
            let leaderOptions = this.getAnnotationLeaderOptions(data);
            let leaderPath = this.annotationLocations[annotationKey].leader.getPath();
            let newPath = leaderOptions.path;
            delete leaderOptions.path;
            if (leaderPath.dontRenderChange) {
              leaderPath.dontRenderChange = false;
            } else {
              newPath.forEach((point, i) => {
                leaderPath.dontSaveChange = true;
                if (leaderPath.getLength() <= i) {
                  leaderPath.push(point);
                } else {
                  leaderPath.setAt(i, point);
                }
              });
              for (var i = newPath.getLength(); i < leaderPath.getLength(); i++) {
                leaderPath.dontSaveChange = true;
                leaderPath.removeAt(i);
              }
            }
            this.annotationLocations[annotationKey].leader.setOptions(leaderOptions);
          }
        } else if (this.annotationLocations[annotationKey].leader) {
          this.annotationLocations[annotationKey].leader.setMap(null);
          delete this.annotationLocations[annotationKey].leader;
        }
      }
    } else if (this.pointLocations[key]) {
      this.pointLocations[key].data = data;
      this.pointLocations[key].position = newLocation;
      // Check if the marker has a label
      if (this.pointLocations[key].labelMarker != null) {
        // Set the label's new position
        this.pointLocations[key].labelMarker.position = newLocation;
      }
      this.applyLocalStyle(data, key, this.pointLocations[key].jobId);
      let iconData = GeoStyleToIcon(data, {
        shrinkDoneItems: this.shrinkDoneItems,
        haloColor: this.layers[this.pointLocations[key].jobId].color,
        hiddenItems: this.pointLocations[key].showOverride ? null : this.hiddenMarkers
      });
      this.pointLocations[key].icon = iconData;
      this.pointLocations[key].zIndex =
        (SquashNulls(this.layers, this.pointLocations[key].jobId, 'zIndex') || 5000) + (SquashNulls(data, 'z') || 0);

      //if there's no icon data or the icon is supposed to be hidden, hide the icon, else show the icon

      // Get the connId and sectionId if this is a section.
      let [connId, sectionId] = this.pointLocations[key].data.t == 's' ? key.split(':') : [];
      // Determine if this point should be hidden or not.
      let hidden = this.pointLocations[key].data.t == 's' ? this.hiddenConnections.includes(connId) : this.hiddenNodes.includes(key);
      if ((this.hiddenMarkers == 'all' && !this.pointLocations[key].jobId?.startsWith('__ref')) || !iconData || hidden) {
        this.pointLocations[key].hide = true;
        //update map based on new marker data
        this.pointLocations[key].map = null;
        if (this.pointLocations[key].geometry) this.pointLocations[key].geometry.setMap(null);
      } else {
        this.pointLocations[key].hide = false;
        this.pointLocations[key].map = this.map;
        if (this.pointLocations[key].geometry) this.pointLocations[key].geometry.setMap(this.map);
      }
    }
  },

  keyExited: function (jobId, key, location, distance, data) {
    key = SquashNulls(this.layers, jobId, 'keyPrefix') + key;
    let layerStyle = SquashNulls(this.layers, jobId, 'style');
    if (layerStyle) {
      data = Object.assign(data, layerStyle);
    }
    if (data.t == 'c') {
      var connId = key.replace(/~[12]$/, '');
      if (this.lineLocations[connId]) {
        this.lineLocations[connId].count--;
        if (this.lineLocations[connId].count == 0) {
          this.removeItem(connId, data.t);
        }
      }
    } else if (data.t == 'a') {
      let annotationKey = key;
      let ids = key.split('~');
      if (ids.length == 2) {
        annotationKey = ids[0];
      }
      if (this.annotationLocations[annotationKey]) {
        this.annotationLocations[annotationKey].count--;
        if (this.annotationLocations[annotationKey].count == 0) {
          this.removeItem(annotationKey, data.t);
        }
      }
    } else {
      // Fire an event when a node exits the view
      this.fire('node-exited-view', { key });
      this.removeItem(key, data.t);
    }
  },

  renderAnnotation: function (data, key, idNumber, jobId) {
    var annotation = new this.TxtOverlay({
      map: this.map,
      data,
      jobId,
      idNumber,
      clickable: this.layers?.[jobId]?.clickable,
      draggable: this.layers?.[jobId]?.clickable && data?.leader?.type != 'angle',
      zIndex: this.layers?.[jobId]?.zIndex || 100,
      fontFamily: 'Helvetica',
      count: 1
    });
    if (data.leader) {
      this.setupAnnotationLeader(annotation, key);
    }
    for (var eventName in this.pointEvents) {
      if (this.pointEvents[eventName].a) {
        google.maps.event.addListener(
          annotation,
          eventName,
          function (eventName, event) {
            let eventDetail = Object.assign(
              {
                ctrlKey: this.ctrlDown,
                metaKey: this.metaDown,
                shiftKey: this.shiftDown,
                altKey: this.altDown,
                geoData: annotation.data,
                marker: annotation,
                jobId: jobId,
                type: 'annotation',
                key: key
              },
              event
            );
            this.fire(this.pointEvents[eventName].a, eventDetail);
          }.bind(this, eventName)
        );
      }
    }
    this.annotationLocations[key] = annotation;
    return annotation;
  },

  setupAnnotationLeader: function (annotation, key) {
    let options = this.getAnnotationLeaderOptions(annotation.data);
    annotation.leader = new google.maps.Polyline(options);
    google.maps.event.addListener(
      options.path,
      'insert_at',
      this.pathUpdated.bind(this, key, annotation.jobId, options.path, 'insert', 'annotationLeader')
    );
    google.maps.event.addListener(
      options.path,
      'remove_at',
      this.pathUpdated.bind(this, key, annotation.jobId, options.path, 'remove', 'annotationLeader')
    );
    google.maps.event.addListener(
      options.path,
      'set_at',
      this.pathUpdated.bind(this, key, annotation.jobId, options.path, 'set', 'annotationLeader')
    );
    // Length dimensions require exactly two endpoints, so right click point removal is not allowed for them.
    if (annotation.data?.leader?.type != 'length') {
      google.maps.event.addListener(annotation.leader, 'rightclick', this.rightClickPath.bind(this, options.path));
    }
  },

  getAnnotationLeaderOptions: function (data) {
    let path = new google.maps.MVCArray(data.leader.points.map((point) => new google.maps.LatLng(point[0], point[1])));
    let r = 1;
    let endPoints = { arrow: google.maps.SymbolPath.FORWARD_CLOSED_ARROW };
    let iconPath = endPoints[data.leader.endPoint] || `M -${r}, 0 a ${r},${r} 0 1,1 ${r * 2},0 a ${r},${r} 0 1,1 -${r * 2},0`;
    let icons = [
      {
        icon: { path: iconPath, strokeColor: data.leader.color, strokeWeight: r * 4 }
      }
    ];
    if (data.leader.doubleEndpoint) {
      icons.push({
        icon: {
          path: data.leader.endPoint == 'arrow' ? google.maps.SymbolPath.BACKWARD_CLOSED_ARROW : iconPath,
          strokeColor: data.leader.color,
          strokeWeight: r * 4
        },
        offset: '0%'
      });
    }
    return {
      path,
      map: this.map,
      strokeColor: data.leader.color,
      icons
    };
  },

  renderPoint: function (data, key, jobId) {
    const haloColor = this.layers[jobId].color;
    this.applyLocalStyle(data, key, jobId);
    const iconData = GeoStyleToIcon(data, {
      shrinkDoneItems: this.shrinkDoneItems,
      haloColor,
      hiddenItems: this.hiddenMarkers
    });
    const lockedNode = this.nodes?.[key]?.position_locked;
    const draggable = jobId == this.mainJobId && !lockedNode ? this.draggable : false;
    const zIndex = (this.layers?.[jobId]?.zIndex ?? 5000) + (data?.z ?? 0);
    const markerOptions = {
      useAdvancedMarkerElement: false,
      position: {
        lat: data.l[0],
        lng: data.l[1]
      },
      clickable: this.clickableNodes,
      customDraggable: draggable,
      icon: iconData,
      zIndex
    };
    // Get the connId and sectionId if this is a section.
    const [connId, sectionId] = data.t == 's' ? key.split(':') : [];
    // Determine if this point should be hidden or not.
    const hidden = data.t == 's' ? this.hiddenConnections.includes(connId) : this.hiddenNodes.includes(key);
    // We should not set a map property for the point if all markers are hidden and this is not a master location directory job.
    // Or we should also hide the marker if there was no iconData, meaning that no icons would render based on the hiddenMarkers list
    if ((this.hiddenMarkers == 'all' && !jobId.startsWith('__ref')) || !iconData || hidden) {
      // options.hide = true;
    } else {
      markerOptions.map = this.map;
    }
    const marker = new HybridMarker(markerOptions);
    Object.assign(marker, {
      haloColor,
      jobId,
      data
    });
    for (const eventType in this.pointEvents) {
      marker.addEventListener(eventType, (event) => {
        const eventDetail = Object.assign(
          {
            ctrlKey: this.ctrlDown,
            metaKey: this.metaDown,
            shiftKey: this.shiftDown,
            altKey: this.altDown,
            geoData: marker.data,
            marker: marker,
            jobId: jobId
          },
          event
        );
        if (marker.data.t == 's') {
          eventDetail.type = 'section';
          eventDetail.connId = connId;
          eventDetail.sectionId = sectionId;
          this.fire(this.pointEvents[eventType].s, eventDetail);
        } else {
          eventDetail.type = 'node';
          eventDetail.key = key;
          this.fire(this.pointEvents[eventType].n, eventDetail);
        }
      });
    }
    const geom = this.layers[jobId].geometry;
    if (geom && google.maps[geom.type]) {
      const options = Object.assign({ map: this.map }, geom.properties);
      if (geom.type == 'Circle') options.center = marker.position;
      marker.geometry = new google.maps[geom.type](options);
    }
    this.pointLocations[key] = marker;
    if (this.zoomToItem == key) {
      this.zoomToItemChanged();
    }
    return marker;
  },

  applyLocalStyle: function (data, key, jobId, localStyle) {
    localStyle = localStyle || this.localStyle;
    if (localStyle && (pageElement.job_id == jobId || pageElement.jobId == jobId || pageElement.jobid == jobId)) {
      let types = {
        n: 'nodes',
        c: 'connections',
        s: 'sections'
      };
      let type = types[data.t];
      let item = pageElement?.[type]?.[key];
      let sectionId = null;
      if (data.t == 's') {
        [key, sectionId] = key.split(':');
        item = pageElement?.connections?.[key]?.sections?.[sectionId];
      }
      if (item) {
        const itemKey = data.t == 's' ? sectionId : key;
        let style = GeofireTools._getItemGeoStyle(type, item, localStyle, itemKey);
        delete data.originalData;
        let originalData = Path.copy(data);
        Object.assign(data, style);
        data.originalData = originalData;
      }
    }
    if (typeof this.computeStyle === 'function') data = this.computeStyle(data, key, jobId);
    return data;
  },

  localStyleChangedHandler: function () {
    this.localStyleChanged();
  },

  localStyleChanged: function (options) {
    const { pointKeysToEvaluate, evaluateExternalPoints } = options || {};
    // Only evaluate the keys in keysToEvaluate if it is provided.
    const pointLocationKeysToEvaluate = pointKeysToEvaluate ?? Object.keys(this.pointLocations ?? {});
    for (const pointLocationKey of pointLocationKeysToEvaluate) {
      if (!this.pointLocations[pointLocationKey]) continue;
      let jobId = this.pointLocations[pointLocationKey].jobId;
      // Ensure the job on the point matches the current job unless external points should also be evaluated
      if (evaluateExternalPoints || pageElement.job_id == jobId || pageElement.jobId == jobId || pageElement.jobid == jobId) {
        this.pointLocations[pointLocationKey].data = this.applyLocalStyle(
          this.pointLocations[pointLocationKey].data.originalData ?? this.pointLocations[pointLocationKey].data,
          pointLocationKey,
          jobId
        );
        let iconData = GeoStyleToIcon(this.pointLocations[pointLocationKey].data, {
          shrinkDoneItems: this.shrinkDoneItems,
          haloColor: this.pointLocations[pointLocationKey].haloColor,
          hiddenItems: this.hiddenMarkers
        });
        this.pointLocations[pointLocationKey].icon = iconData;
      }
    }
    for (var key in this.lineLocations) {
      let jobId = this.lineLocations[key].jobId;
      if (pageElement.job_id == jobId || pageElement.jobId == jobId || pageElement.jobid == jobId) {
        this.lineLocations[key].data = this.applyLocalStyle(
          this.lineLocations[key].data.originalData ?? this.lineLocations[key].data,
          key.split('~')[0],
          jobId
        );
        let lineOptions = this.getConnOptions(this.lineLocations[key].data);
        for (var prop in this.lineLocations[key].override) {
          delete lineOptions[prop];
        }
        this.lineLocations[key].setOptions(lineOptions);
      }
    }
  },

  removeItem: function (key, type) {
    if (type == 'c' && this.lineLocations[key]?.showOverride) return;
    if (type == 'a' && this.annotationLocations[key]?.showOverride) return;
    if (type != 'c' && type != 'c' && this.pointLocations[key]?.showOverride) return;
    requestAnimationFrame(() => {
      if (type == 'c') {
        if (this.lineLocations[key]) {
          this.lineLocations[key].setMap(null);
          google.maps.event.clearInstanceListeners(this.lineLocations[key]);
          if (this.lineLocations[key].labelMarker) {
            this.lineLocations[key].labelMarker.map = null;
            google.maps.event.clearInstanceListeners(this.lineLocations[key].labelMarker);
          }
          this.removeLineLabelListeners(key);
          for (var item in this.lineLocations[key].overlays) {
            this.lineLocations[key].overlays[item].setMap(null);
            if (this.lineLocations[key].overlays[item].ref) {
              this.lineLocations[key].overlays[item].ref.off('value', this.lineLocations[key].overlays[item].listener);
            }
          }
          delete this.lineLocations[key];
        }
      } else if (type == 'a') {
        if (this.annotationLocations[key]) {
          this.annotationLocations[key].setMap(null);
          google.maps.event.clearInstanceListeners(this.annotationLocations[key]);
          if (this.annotationLocations[key].leader) this.annotationLocations[key].leader.setMap(null);
          delete this.annotationLocations[key];
        }
      } else {
        if (this.pointLocations[key]) {
          this.pointLocations[key].map = null;
          google.maps.event.clearInstanceListeners(this.pointLocations[key]);
          if (this.pointLocations[key].geometry) this.pointLocations[key].geometry.setMap(null);
          if (this.pointLocations[key].labelMarker) {
            this.pointLocations[key].labelMarker.map = null;
            google.maps.event.clearInstanceListeners(this.pointLocations[key].labelMarker);
          }
          this.removePointLabelListeners(key);
          delete this.pointLocations[key];
          this.pointCount--;
          // this.clusterer.removeMarker(key, true);
          // this.pointCount--;
          // this.debounce('redraw map', function() {
          //   this.clusterer.redraw();
          // }, 16);
        }
        if (type == 's') {
          var ids = key.split(':');
          if (this.sectionList[ids[0]]) delete this.sectionList[ids[0]].sections[ids[1]];
        }
      }
    });
  },

  hideShowMarkers: function () {
    for (var key in this.pointLocations) {
      let point = this.pointLocations[key];
      // Get the icon data for the point to determine if the icon should be partially shown or not.
      // If iconData is null, then no icons were able to render based on hiddenMarkers
      this.applyLocalStyle(this.pointLocations[key].data, key, this.pointLocations[key].jobId);
      let iconData = GeoStyleToIcon(point.data, {
        shrinkDoneItems: this.shrinkDoneItems,
        haloColor: this.layers[point.jobId].color,
        hiddenItems: this.hiddenMarkers
      });
      // Get the connId and sectionId if this is a section.
      let [connId, sectionId] = point.data.t == 's' ? key.split(':') : [];
      // Determine if this point should be hidden or not.
      let hidden = point.data.t == 's' ? this.hiddenConnections.includes(connId) : this.hiddenNodes.includes(key);
      // Hide Point
      if ((this.hiddenMarkers == 'all' && !point.jobId.startsWith('__ref')) || !iconData || hidden) {
        // Flag the point as hidden.
        point.hide = true;
        // Remove the point from the map.
        point.map = null;
        if (point.geometry) point.geometry.setMap(null);
        // Remove the point's label from the map.
        if (point.labelMarker) point.labelMarker.map = null;
      }
      // Show Point and update icon
      else {
        // Clear point's hidden flag.
        point.hide = false;
        // Update the point's icon.
        point.icon = iconData;
        // Add the point to the map.
        point.map = this.map;
        // Set the point's label to the map.
        if (point.labelMarker) point.labelMarker.map = this.map;
        if (point.geometry) point.geometry.setMap(this.map);
      }
    }

    for (var key in this.lineLocations) {
      let line = this.lineLocations[key];
      // Hide Line
      if (
        (this.hiddenMarkers == 'all' && !line.jobId.startsWith('__ref')) ||
        (this.hiddenMarkers != null && this.hiddenMarkers[line.data.u]) ||
        this.hiddenConnections.includes(key)
      ) {
        // Flag the line as hidden.
        line.hide = true;
        // Remove the line from the map.
        line.setMap(null);
        // Remove the line's label from the map.
        if (line.labelMarker) line.labelMarker.map = null;
      }
      // Show Line
      else {
        // Clear the line's hidden flag.
        line.hide = false;
        // Add the line to the map.
        line.setMap(this.map);
        // Ad the line's label to the map.
        if (line.labelMarker) line.labelMarker.map = this.map;
      }
    }
    // if (this.clusterer.cluster) {
    //   this.clusterer.shouldRedraw = true;
    //   this.clusterer.resetViewport();
    //   this.clusterer.redraw();
    // }
  },

  updateLabelListeners: function (changeEvent) {
    const changeEventWasTurningOffLabel = changeEvent.value == false;
    const hasAnyLabelsOn = Object.values(this.labeledAttributes || {}).some((value) => value);

    if (!hasAnyLabelsOn) {
      this.stopLabelListenerQueue();
      for (var key in this.pointLocations) {
        this.removePointLabelListeners(key);
        this.pointLocations[key].labelData = {};
        this.updatePointLabel(key);
      }
      for (let key in this.lineLocations) {
        this.removeLineLabelListeners(key);
        this.lineLocations[key].labelData = {};
        this.updateConnLabel(key);
      }
      return;
    }

    if (changeEventWasTurningOffLabel) {
      const attributeTurnedOff = changeEvent.path.split('.').pop();
      for (var key in this.pointLocations) {
        this.removePointLabelListeners(key, [attributeTurnedOff]);
        if (this.pointLocations[key].labelData) this.pointLocations[key].labelData[attributeTurnedOff] = {};
        this.updatePointLabel(key);
      }
      for (let key in this.lineLocations) {
        this.removeLineLabelListeners(key, [attributeTurnedOff]);
        if (this.lineLocations[key].labelData) this.lineLocations[key].labelData[attributeTurnedOff] = {};
        this.updateConnLabel(key);
      }
      return;
    }

    for (var key in this.pointLocations) {
      this.removePointLabelListeners(key);
      var attributesUrl = 'photoheight/jobs/' + this.pointLocations[key].jobId;
      if (this.pointLocations[key].data.t == 's') {
        var ids = key.split(':');
        attributesUrl += '/connections/' + ids[0] + '/sections/' + ids[1] + '/multi_attributes/';
      } else {
        attributesUrl += '/nodes/' + key + '/attributes/';
      }
      this.addPointLabelListeners(key, attributesUrl);
    }
    // Remove any labels from connections
    for (let key in this.lineLocations) {
      this.removeLineLabelListeners(key);
      let attributesUrl = `photoheight/jobs/${this.lineLocations[key].jobId}/connections/${key}/attributes/`;
      this.addLineLabelListeners(key, attributesUrl);
    }
  },

  labelFontSizeChanged: function () {
    for (var key in this.pointLocations) {
      this.updatePointLabel(key);
    }
    for (var key in this.lineLocations) {
      this.updateConnLabel(key);
    }
  },

  stopLabelListenerQueue: function () {
    if (this.labelListenerQueueTimeout) {
      clearTimeout(this.labelListenerQueueTimeout);
      this.labelListenerQueueTimeout = null;
    }
    this.labelListenerQueue = [];
  },

  queueLabelListenerRequest: function (type, key, attributesUrl) {
    this.labelListenerQueue.push({ type, key, attributesUrl });
    this.processLabelListenerQueue();
  },

  processLabelListenerQueue: function () {
    if (this.labelListenerQueueTimeout || this.labelListenerQueue.length == 0) return;
    const request = this.labelListenerQueue.shift();
    if (request.type == 'line') {
      this._addLineLabelListeners(request.key, request.attributesUrl);
    } else if (request.type == 'point') {
      this._addPointLabelListeners(request.key, request.attributesUrl);
    }
    this.labelListenerQueueTimeout = setTimeout(() => {
      this.labelListenerQueueTimeout = null;
      this.processLabelListenerQueue();
    }, this.labelListenerQueueDelay);
  },

  addLineLabelListeners(key, attributesUrl) {
    // Allow labels from main job to process right away
    const lineIsFromMainJob = this.lineLocations[key]?.jobId == this.mainJobId;
    if (lineIsFromMainJob) {
      this._addLineLabelListeners(key, attributesUrl);
      return;
    }
    // If they can't show labels on job layers, skip adding listeners
    if (!this.enabledFeatures?.show_job_layer_labels) return;
    this.queueLabelListenerRequest('line', key, attributesUrl);
  },

  _addLineLabelListeners(key, attributesUrl) {
    if (!this.lineLocations[key]) return;
    this.lineLocations[key].labelData = {};
    for (var attribute in this.labeledAttributes) {
      if (this.labeledAttributes[attribute]) {
        // only create the listener if the attribute is allowed to be on a connection
        if (this.otherAttributes?.[attribute]?.attribute_types?.includes('connection')) {
          this.lineLocations[key].labelData[attribute] = {
            value: {},
            observers: { attribute: { ref: FirebaseWorker.ref(attributesUrl + attribute) } }
          };
          this.lineLocations[key].labelData[attribute].observers.attribute.listener = this.lineLocations[key].labelData[
            attribute
          ].observers.attribute.ref.on(
            'value',
            function (key, attribute, s) {
              if (this.lineLocations[key]) {
                this.lineLocations[key].labelData[attribute].value = s.val();
                this.updateConnLabel(key);
              }
            }.bind(this, key, attribute)
          );
        }
      }
    }
    this.updateConnLabel(key);
  },

  removeLineLabelListeners(key, attributesToRemove) {
    attributesToRemove = attributesToRemove || Object.keys(this.lineLocations[key]?.labelData || {});
    for (var attribute of attributesToRemove) {
      for (var item in this.lineLocations[key].labelData?.[attribute]?.observers) {
        this.lineLocations[key].labelData[attribute].observers[item].ref.off(
          'value',
          this.lineLocations[key].labelData[attribute].observers[item].listener
        );
      }
    }
  },

  addPointLabelListeners(key, attributesUrl) {
    // Allow labels from main job to process right away
    const pointIsFromMainJob = this.pointLocations[key]?.jobId == this.mainJobId;
    if (pointIsFromMainJob) {
      this._addPointLabelListeners(key, attributesUrl);
      return;
    }
    // If they can't show labels on job layers, skip adding listeners
    if (!this.enabledFeatures?.show_job_layer_labels) return;
    this.queueLabelListenerRequest('point', key, attributesUrl);
  },

  _addPointLabelListeners(key, attributesUrl) {
    if (!this.pointLocations[key]) return;
    this.pointLocations[key].labelData = {};
    for (var attribute in this.labeledAttributes) {
      if (this.labeledAttributes[attribute]) {
        if (attribute == 'lowCable') {
          let marker = this.pointLocations[key];
          let photosUrl = 'photoheight/jobs/' + marker.jobId;
          if (key.indexOf(':') != -1) {
            var ids = key.split(':');
            photosUrl += '/connections/' + ids[0] + '/sections/' + ids[1] + '/photos/';
          } else {
            photosUrl += '/nodes/' + key + '/photos/';
          }
          this.pointLocations[key].labelData['Low Cable'] = {
            value: {},
            observers: { itemPhotos: { ref: FirebaseWorker.ref(photosUrl) } }
          };
          this.pointLocations[key].labelData['Low Cable'].observers.itemPhotos.listener = this.pointLocations[key].labelData[
            'Low Cable'
          ].observers.itemPhotos.ref.on(
            'value',
            function (key, s) {
              if (this.pointLocations[key]) {
                var photos = s.val();
                for (var photoId in photos) {
                  if (photos[photoId] == 'main' || photos[photoId].association == 'main') {
                    this.pointLocations[key].labelData['Low Cable'].observers.wires = {
                      ref: FirebaseWorker.ref('photoheight/jobs/' + marker.jobId + '/photos/' + photoId + '/photofirst_data/wire')
                    };
                    this.pointLocations[key].labelData['Low Cable'].observers.wires.listener = this.pointLocations[key].labelData[
                      'Low Cable'
                    ].observers.wires.ref.on(
                      'value',
                      function (key, s) {
                        if (this.pointLocations[key]) {
                          var wires = s.val();
                          var lowest = { height: Infinity };
                          for (var itemKey in wires) {
                            var ht = wires[itemKey]._measured_height || wires[itemKey]._manual_height;
                            if (ht != null && ht < lowest.height) {
                              lowest = { height: ht, trace: wires[itemKey]._trace };
                            }
                          }
                          if (lowest.trace) {
                            this.pointLocations[key].labelData['Low Cable'].observers.trace = {
                              ref: FirebaseWorker.ref('photoheight/jobs/' + marker.jobId + '/traces/trace_data/' + lowest.trace)
                            };
                            this.pointLocations[key].labelData['Low Cable'].observers.trace.listener = this.pointLocations[key].labelData[
                              'Low Cable'
                            ].observers.trace.ref.on(
                              'value',
                              function (key, s) {
                                if (this.pointLocations[key]) {
                                  let trace = s.val();
                                  this.pointLocations[key].labelData['Low Cable'].value = {
                                    label:
                                      (trace.company || 'Wire') +
                                      ' at ' +
                                      FormatHeight(lowest.height, this.useMetricUnits ? 'meters' : 'feet-inches', 2)
                                  };
                                  this.updatePointLabel(key);
                                }
                              }.bind(this, key)
                            );
                          }
                        }
                      }.bind(this, key)
                    );
                    break;
                  }
                }
              }
            }.bind(this, key)
          );
        } else if (attribute == 'photoCount') {
          let marker = this.pointLocations[key];
          let photosUrl = 'photoheight/jobs/' + marker.jobId;
          if (key.indexOf(':') != -1) {
            var ids = key.split(':');
            photosUrl += '/connections/' + ids[0] + '/sections/' + ids[1] + '/photos/';
          } else {
            photosUrl += '/nodes/' + key + '/photos/';
          }
          this.pointLocations[key].labelData['Photo Count'] = {
            value: {},
            observers: { itemPhotos: { ref: FirebaseWorker.ref(photosUrl) } }
          };
          this.pointLocations[key].labelData['Photo Count'].observers.itemPhotos.listener = this.pointLocations[key].labelData[
            'Photo Count'
          ].observers.itemPhotos.ref.on(
            'value',
            function (key, s) {
              if (this.pointLocations[key]) {
                var photoCount = Object.keys(s.val() || {}).length;
                if (photoCount != 0) {
                  this.pointLocations[key].labelData['Photo Count'].value = { label: photoCount };
                } else {
                  delete this.pointLocations[key].labelData['Photo Count'].value;
                }
                this.updatePointLabel(key);
              }
            }.bind(this, key)
          );
        } else {
          // only create the listener if the attribute is allowed to be on a node or section
          if (
            (this.otherAttributes?.[attribute]?.attribute_types?.includes('node') && key.indexOf(':') == -1) ||
            (this.otherAttributes?.[attribute]?.attribute_types?.includes('section') && key.indexOf(':') != -1)
          ) {
            this.pointLocations[key].labelData[attribute] = {
              value: {},
              observers: { attribute: { ref: FirebaseWorker.ref(attributesUrl + attribute) } }
            };
            this.pointLocations[key].labelData[attribute].observers.attribute.listener = this.pointLocations[key].labelData[
              attribute
            ].observers.attribute.ref.on(
              'value',
              function (key, attribute, s) {
                if (this.pointLocations[key]) {
                  this.pointLocations[key].labelData[attribute].value = s.val();
                  this.updatePointLabel(key);
                }
              }.bind(this, key, attribute)
            );
          }
        }
      }
    }
    this.updatePointLabel(key);
  },

  removePointLabelListeners(key, attributesToRemove) {
    attributesToRemove = attributesToRemove || Object.keys(this.pointLocations[key]?.labelData || {});
    for (var attribute of attributesToRemove) {
      for (var item in this.pointLocations[key].labelData?.[attribute]?.observers) {
        this.pointLocations[key].labelData[attribute].observers[item].ref.off(
          'value',
          this.pointLocations[key].labelData[attribute].observers[item].listener
        );
      }
    }
  },

  updatePointLabel: function (key) {
    this.debounce(
      'update-label-' + key,
      function (key) {
        var marker = this.pointLocations[key];
        var label = '';
        if (marker) {
          var mapNoteColors = false;
          // Flag for if we should show the names of attributes in the label
          // We should do this if there is more than one attribute displayed
          let showAttributeNames = Object.values(marker.labelData || {}).filter((x) => x.value != null).length > 1;
          for (var attribute in marker.labelData) {
            for (var itemKey in marker.labelData[attribute].value) {
              var value = this.getAttributeLabel(attribute, marker.labelData[attribute].value[itemKey]);
              if (value != null && value !== '') {
                if (label != '') label += '\n';
                if (attribute == 'note' && this.jobCreator != null && this.jobCreator.includes('davey')) {
                  mapNoteColors = true;
                } else {
                  if (showAttributeNames) label += ToTitleCase(attribute) + ': ';
                }
                label += value;
              }
            }
          }
          if (label.endsWith('\n ')) {
            label = label.slice(0, -2);
          }
          var color = 'white';
          var backgroundColor = 'rgba(0,0,0,0.25)';
          if (mapNoteColors) {
            color = 'black';
            backgroundColor = 'rgba(255,255,255,0.6)';
          }
          var icon = this.getSVGLabel(label, {
            padding: 4,
            xOffset: 10,
            yOffset: 10,
            xAnchor: 'left',
            yAnchor: 'bottom',
            textAlign: 'left',
            color,
            backgroundColor,
            fontSize: this.labelFontSize ? `${this.labelFontSize}pt` : null
          });
          const hasLabel = label != '';
          if (marker.labelMarker == null) {
            if (hasLabel) {
              marker.labelMarker = new HybridMarker({
                map: marker.map,
                position: marker.position,
                clickable: false,
                zIndex: marker.zIndex,
                icon
              });
            }
          } else {
            Object.assign(marker.labelMarker, {
              map: hasLabel ? marker.map : null,
              position: marker.position,
              zIndex: marker.zIndex,
              icon,
              visible: hasLabel
            });
          }
        }
      }.bind(this, key),
      16
    );
  },

  getAttributeLabel: function (property, value, divider) {
    let gui_element = this.otherAttributes[property]?.gui_element;
    if (gui_element == 'table') {
      let table_items = this.otherAttributes[property]?.table_items;
      let label = '';
      table_items.forEach((item) => {
        if (label != '') label += '\n';
        let attribute = item?.attribute;
        label += `${ToTitleCase(attribute)} - ${this.getAttributeLabel(attribute, value[attribute], divider)}`;
      });
      label += `\n `;
      return label;
    }
    if (property == 'time_bucket') return this.formatTime(value.start) + '-' + this.formatTime(value.stop);
    else if (property == 'pole_tag') return (value.company || 'company not set!') + ' - ' + value.tagtext;
    else if (property == 'sizes_of_attached_dn_guys') {
      let label = '';
      let sizes = value.replace(/\s+/g, '').split(',');
      label += sizes.join(divider || ', ');
      return label;
    } else return value;
  },

  formatTime: function (time) {
    if (time == null) return '';
    var date = new Date(time);
    var hours = ('0' + date.getHours()).slice(-2);
    var minutes = ('0' + date.getMinutes()).slice(-2);
    var seconds = ('0' + date.getSeconds()).slice(-2);
    return hours + ':' + minutes + ':' + seconds;
  },

  encodeHTMLString: function (text) {
    if (!text) return '';
    return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  },

  /**
    text
    options
      rotation
      padding
      spaceBetween
      xOffset
      yOffset
      xAnchor
      yAnchor
      textAlign
      color
      backgroundColor
      fontSize
  */
  getSVGLabel: function (text, options) {
    // Set defaults for the options object
    options = options || {};
    options.rotation = options.rotation || 0;
    options.padding = options.padding || 0;
    // Set to add some space in between the lines of text, if any
    options.spaceBetween = options.spaceBetween || 0;
    options.xOffset = options.xOffset || 0;
    options.yOffset = options.yOffset || 0;
    options.textAlign = options.textAlign || 'left';
    options.xAnchor = options.xAnchor || 'left';
    options.yAnchor = options.yAnchor || 'top';
    options.color = options.color || 'black';
    options.fontSize = options.fontSize || '8pt';

    let width = 0,
      height = 0,
      tspans = '',
      lineHeight = 0;
    // Split the text up by new lines
    let lines = (text || '').split('\n');
    // Check if we should show blank lines and if so, map each empty
    // item in the lines array to a space character
    if (options.showBlankLines) lines = lines.map((x) => (x == '' ? '&#160;' : x));
    // Calculate the width and height of the text by looping through each line
    lines.forEach((line) => {
      // Get the text dimensions for the line and increase the width if needed
      let lineDimensions = this.getTextDimensions(line, options.fontSize);
      if (lineDimensions.width > width) width = lineDimensions.width;
      lineHeight = lineDimensions.height;
      // Increase the height by the line height
      // plus optional space in between the lines
      height += lineDimensions.height + options.spaceBetween;
    });
    // Get the position of the middle of the text height
    let middleTextHeight = lineHeight / 2;
    // Add double padding for top and bottom, and take one spaceBetween off of height
    // to account for the last line adding space between height when it shouldn't have.
    height += options.padding * 2 - options.spaceBetween;
    width += options.padding * 2;
    // Get bounding box side lengths. This is twice the distance between the origin and the furthest corner of the label.
    // This calculation is needed to account for the possible rotation of the text
    let boundingBox =
      2 *
      Math.sqrt(
        Math.pow((options.xAnchor == 'center' ? width / 2 : width) + Math.abs(options.xOffset) * 2, 2) +
          Math.pow((options.yAnchor == 'center' ? height / 2 : height) + Math.abs(options.yOffset) * 2, 2)
      );

    let backgroundShape = '';
    // Check if we should have a background shape, and update the bounding box accordingly
    if (options.backgroundShape) {
      backgroundShape = this.getBackgroundShape(options.backgroundShape, {
        stroke: options.backgroundStroke,
        strokeWidth: options.backgroundStrokeWidth,
        fill: options.backgroundColor
      });

      let newSize = Math.max(width, height);
      newSize *= 1.5;
      boundingBox = newSize;
      backgroundShape = `<svg viewBox="0 0 24 24" width="${newSize}" height="${newSize}">${backgroundShape}</svg>`;
    }

    // Get X and Y offsets of the label relative to the bounding box.
    let xLabelOffset = 0;
    let yLabelOffset = 0;
    if (options.xAnchor == 'left') {
      xLabelOffset = boundingBox / 2 + options.xOffset;
    } else if (options.xAnchor == 'center') {
      xLabelOffset = (boundingBox - width) / 2 + options.xOffset;
    } else if (options.xAnchor == 'right') {
      xLabelOffset = boundingBox / 2 - width + options.xOffset;
    }
    if (options.yAnchor == 'top') {
      yLabelOffset = boundingBox / 2 - options.yOffset;
    } else if (options.yAnchor == 'center') {
      yLabelOffset = (boundingBox - height) / 2 - options.yOffset;
    } else if (options.yAnchor == 'bottom') {
      yLabelOffset = boundingBox / 2 - height - options.yOffset;
    }
    // Get text align and X and Y offsets relative to bounding box.
    let textAnchor = '';
    let xTextOffset = 0;
    let yTextOffset = yLabelOffset + options.padding + middleTextHeight;
    if (options.textAlign == 'left') {
      textAnchor = 'start';
      xTextOffset = xLabelOffset + options.padding;
    } else if (options.textAlign == 'center') {
      textAnchor = 'middle';
      xTextOffset = xLabelOffset + width / 2;
    } else if (options.textAlign == 'right') {
      textAnchor = 'end';
      xTextOffset = xLabelOffset + width - options.padding;
    }
    // Build up a string of svg <tspan> elements for each line.
    lines.forEach((line, i) => {
      let lineDimensions = this.getTextDimensions(line, options.fontSize);
      // replace % sign if it exists in each line
      line = line.replaceAll('%', '%25');
      tspans += `<tspan x="${xTextOffset}" dy="${
        i ? lineDimensions.height + options.spaceBetween : 0
      }" text-anchor="${textAnchor}" alignment-baseline="middle" fill="${options.color}" font-weight="lighter">${
        line == '&#160;' ? line : this.encodeHTMLString(line)
      }</tspan>`;
    });

    let svgBackground = options.backgroundShape
      ? backgroundShape
      : options.backgroundColor
        ? `<rect x="${xLabelOffset}" y="${yLabelOffset}" width="${width}" height="${height}" style="fill:${options.backgroundColor}; stroke:${options.backgroundStroke}; stroke-width:${options.backgroundStrokeWidth};" rx="6" ry="6"></rect>`
        : '';

    let url = `
      data:image/svg+xml,
      <svg xmlns="http://www.w3.org/2000/svg" width="${boundingBox}" height="${boundingBox}">
        <g transform="rotate(${options.rotation} ${boundingBox / 2} ${boundingBox / 2})" clip-path="url(#clip1)">
          ${svgBackground}
          <text x="0" y="${yTextOffset}" font-size="${options.fontSize}" font-family="Helvetica">${tspans}</text>
        </g>
      </svg>`;
    // ${(options.maxWidth || options.maxHeight) ?
    //       `<clipPath id="clip1">
    //         <rect x="0" y="0" width="${options.maxWidth || width}" height="${options.maxHeight || height}"/>
    //       </clipPath>`:''
    //     }

    url = url.replace(/\#/g, '%23');

    return {
      size: { width: boundingBox, height: boundingBox },
      rectSize: { width, height },
      anchor: { x: boundingBox / 2, y: boundingBox / 2 },
      url
    };
  },

  getBackgroundShape: function (backgroundShape, options) {
    // Get the group and name of the icon to use
    let iconGroup = backgroundShape.split(':')[0];
    let iconName = backgroundShape.split(':')[1];
    // Get the content for the icon
    let iconSet = this.$.meta.byKey(iconGroup);
    let iconContent = iconSet.applyIcon(document.createElement('text'), iconName);
    iconContent = iconContent.innerHTML;
    // Hack to fix stroke width. Is there a better way to do this?
    iconContent = iconContent.replace(
      /stroke-width="\d+"/,
      `fill="${options.fill}" stroke="${options.stroke}" stroke-width="${options.strokeWidth}"`
    );
    return iconContent;
  },

  getTextDimensions: function (text, fontSize) {
    this.$.ruler.style.fontSize = fontSize;
    this.$.ruler.textContent = text;
    let temp = { width: Math.ceil(this.$.ruler.offsetWidth), height: Math.ceil(this.$.ruler.offsetHeight) };
    return temp;
  },

  renderConn: function (data, key, idNumber, jobId) {
    var points = [];
    this.applyLocalStyle(data, key, jobId);
    var options = this.getConnOptions(data);
    if (data.i && Array.isArray(data.i)) {
      data.i.forEach((p) => {
        points.push(new google.maps.LatLng(p[0], p[1]));
      });
    } else {
      var p1 = new google.maps.LatLng(data.l[0], data.l[1]);
      var p2 = new google.maps.LatLng(data.l2[0], data.l2[1]);
      if (idNumber == 2) {
        var t = p1;
        p1 = p2;
        p2 = t;
      }
      points = [p1, p2];
      if (data.b) {
        for (var i = 0; i < data.b.length; i++) {
          points.splice(-1, 0, new google.maps.LatLng(data.b[i][0], data.b[i][1]));
        }
      }
    }
    var path = new google.maps.MVCArray(points);
    options.clickable = this.clickableConnections;
    if (jobId && this.layers[jobId] && this.layers[jobId].clickable != null) options.clickable = this.layers[jobId].clickable;
    options.path = path;
    if (
      (this.hiddenMarkers == 'all' && !jobId.startsWith('__ref')) ||
      (this.hiddenMarkers != null && this.hiddenMarkers[data.u]) ||
      this.hiddenConnections.includes(key)
    ) {
      options.hide = true;
    } else {
      options.map = this.map;
    }
    var p = new google.maps.Polyline(options);
    if (this.setConnEditable == key) {
      this.setConnEditable = null;
      this.setupPolylineListeners(path, p, key, jobId);
    }
    google.maps.event.addListener(p, 'drag', (event) => {});
    google.maps.event.addListener(p, 'click', (event) => {
      let eventDetail = Object.assign(
        {
          geoData: p.data,
          polyline: p,
          key: key,
          jobId: jobId,
          type: 'connection'
        },
        event
      );
      this.fire('conn-click', eventDetail);
    });
    p.count = 1;
    p.length = data.d;
    p.idNumber = idNumber;
    p.jobId = jobId;
    p.data = data;
    p.haloColor = this.layers[jobId].color;
    if ((this.hiddenMarkers == 'all' && !jobId.startsWith('__ref')) || (this.hiddenMarkers != null && this.hiddenMarkers[p.data.u])) {
      p.hide = true;
    }
    p.overlays = {};
    if (this.layers[jobId].color) this.getConnHalo(p);
    if (this.cableTracing) this.enableTraceOverlay(key, p);
    this.lineLocations[key] = p;
    if (this.shouldShowLabelForConn(key)) this.updateConnLabel(key);
    if (this.zoomToItem == key) {
      this.zoomToItemChanged();
    }
    return p;
  },

  getConnHalo: function (line) {
    line.overlays.halo = new google.maps.Polyline({
      path: line.getPath(),
      strokeColor: typeof line.haloColor == 'function' ? line.haloColor(line.data) : line.haloColor,
      strokeWeight: line.strokeWeight * 2.1,
      strokeOpacity: 1,
      zIndex: -2
    });
  },

  findSVGPath: function (item) {
    if (item && item.tagName == 'path') return item.getAttribute('d');
    else if (item && item.children && item.children[0]) return this.findSVGPath(item.children[0]);
  },

  getConnOptions: function (data) {
    let icons = [];

    if (data.p == 'dashed') {
      icons.push({
        icon: { path: 'M 0,-1 0,1', strokeOpacity: data.o || 0.5, scale: data.w },
        offset: '25px',
        repeat: 6.5 * data.w + 'px'
      });
    } else {
      let pattern = data.p?.split(' ').map((x) => Number(x));
      if (pattern.every((x) => !isNaN(x))) {
        let strokeWeight = Number(data.w);
        let totalLength = 0;
        pattern.forEach((item, index) => {
          totalLength += index % 2 == 0 ? item : (item * strokeWeight) / 4;
        });
        let offset = 0;
        pattern.forEach((item, index) => {
          for (let i = 0; i < item; i++) {
            if (index % 2 == 0) {
              icons.push({
                icon: { path: 'M 0,-0.25 0,0.25', strokeOpacity: data.o || 0.5, strokeWeight, scale: 1 },
                offset: offset + 'px',
                repeat: totalLength + 'px'
              });
              offset++;
            } else {
              offset += strokeWeight / 4;
            }
          }
        });
      }
    }

    if (data.ci) {
      let iconData = GeoStyleToIcon(data);
      if (iconData) {
        let svgText = iconData.url.replace('data:image/svg+xml,', '');
        var parser = new DOMParser();
        var doc = parser.parseFromString(svgText, 'image/svg+xml');
        if (doc) {
          let path = this.findSVGPath(doc);
          if (path) {
            icons.push({
              icon: {
                path,
                anchor: { x: 11, y: 11 },
                scale: data.cis || 1.5,
                fillColor: data.cic,
                fillOpacity: 1,
                strokeColor: 'black',
                strokeOpacity: 1
              },
              offset: '50%',
              fixedRotation: true
            });
          }
        }
      }
    }

    return {
      strokeColor: data.c,
      strokeOpacity: data.p == 'solid' ? data.o : 0,
      strokeWeight: data.w || 6,
      icons: icons.length ? icons : null,
      zIndex: data.z || 1
    };
  },

  setupPolylineListeners: function (path, line, key, jobId) {
    if (!path.hasListeners) {
      path.hasListeners = true;
      line.setOptions({ editable: true });
      google.maps.event.addListener(path, 'insert_at', this.pathUpdated.bind(this, key, jobId, path, 'insert', 'conn'));
      google.maps.event.addListener(path, 'remove_at', this.pathUpdated.bind(this, key, jobId, path, 'remove', 'conn'));
      google.maps.event.addListener(path, 'set_at', this.pathUpdated.bind(this, key, jobId, path, 'set', 'conn'));
      google.maps.event.addListener(line, 'rightclick', this.rightClickPath.bind(this, path));
    }
  },

  pathUpdated: function (key, jobId, path, eventType, itemType, index, prev) {
    if (path.dontSaveChange) {
      path.dontSaveChange = false;
      return;
    }
    if (itemType == 'conn' && eventType == 'set' && (index == 0 || index == path.getLength() - 1)) {
      path.dontSaveChange = true;
      path.setAt(index, prev);
      return;
    }
    var pathArray = path.getArray();
    var points = [];
    var startIndex = 0;
    var len = pathArray.length;
    if (itemType == 'conn') {
      startIndex++;
      len--;
    }
    for (var i = startIndex; i < len; i++) {
      points.push([pathArray[i].lat(), pathArray[i].lng()]);
      if (itemType == 'conn') this.set(`polylinePoints.${i}`, [pathArray[i].lat(), pathArray[i].lng()]);
    }
    var update = {};
    if (itemType == 'conn') {
      var length = Round(google.maps.geometry.spherical.computeLength(path) / 0.3048, 1);
      update['photoheight/jobs/' + jobId + '/geohash/' + key + '~1/b'] = points;
      update['photoheight/jobs/' + jobId + '/geohash/' + key + '~2/b'] = points;
      update['photoheight/jobs/' + jobId + '/connections/' + key + '/breakpoints'] = points;
      update['photoheight/jobs/' + jobId + '/geohash/' + key + '~1/d'] = length;
      update['photoheight/jobs/' + jobId + '/geohash/' + key + '~2/d'] = length;
    } else if (itemType == 'annotationLeader') {
      // Length dimensions use their leader as the dimension line between two fixed endpoints.
      // Dragging an endpoint recomputes the measured length and re-centers the label instead of
      // snapping the leader to the annotation box.
      if (this.annotationLocations[key]?.data?.leader?.type == 'length') {
        // Only the two endpoints are editable, so revert any midpoint that was inserted.
        if (eventType == 'insert') {
          path.dontSaveChange = true;
          path.removeAt(index);
          return;
        }
        globalThis.printModeToolbar.getLengthDimensionLeaderUpdate(key, points, update);
      } else {
        let lineSnap = this.snapToClosestLine(key);
        points.splice(0, 1, [lineSnap.snap.lat(), lineSnap.snap.lng()]);
        path.dontSaveChange = true;
        path.setAt(0, lineSnap.snap);
        for (let i = 1; i < 5; i++) {
          update[this.layers[jobId].url + '/' + key + '~' + i + '/leader/points'] = points;
          update[this.layers[jobId].url + '/' + key + '~' + i + '/leader/edge'] = lineSnap.edge;
          update[this.layers[jobId].url + '/' + key + '~' + i + '/leader/percent'] = lineSnap.percent;
          update[this.layers[jobId].url + '/' + key + '~' + i + '/leader/snapToNode'] = null;
        }
      }
    }
    path.dontRenderChange = true;
    FirebaseWorker.ref().update(update, (err) => {
      if (err) console.log(err);
    });
  },

  snapToClosestLine: function (key, lineIndex) {
    let annotation = this.annotationLocations[key];
    // Get array of lines which make up the annotation.
    let lines = [
      [annotation.topLeft, annotation.topRight],
      [annotation.topRight, annotation.bottomRight],
      [annotation.bottomRight, annotation.bottomLeft],
      [annotation.bottomLeft, annotation.topLeft]
    ];
    let lineNames = ['top', 'right', 'bottom', 'left'];

    let leaderEndpoint = annotation.leader.getPath().getAt(0);

    // Find the line which last point is closest to.
    if (lineIndex == null) {
      lineIndex = 0;
      let shortest = KatapultGeometry.CalcDistanceToLine(
        leaderEndpoint.lat(),
        leaderEndpoint.lng(),
        lines[0][0].lat(),
        lines[0][0].lng(),
        lines[0][1].lat(),
        lines[0][1].lng()
      );
      for (let i = 1; i < lines.length; i++) {
        let length = KatapultGeometry.CalcDistanceToLine(
          leaderEndpoint.lat(),
          leaderEndpoint.lng(),
          lines[i][0].lat(),
          lines[i][0].lng(),
          lines[i][1].lat(),
          lines[i][1].lng()
        );
        if (length < shortest) {
          shortest = length;
          lineIndex = i;
        }
      }
    }

    let nearestLine = lines[lineIndex];
    // Snap last point to nearest line.
    let snap = KatapultGeometry.SnapToLine(
      leaderEndpoint.lat(),
      leaderEndpoint.lng(),
      nearestLine[0].lat(),
      nearestLine[0].lng(),
      nearestLine[1].lat(),
      nearestLine[1].lng()
    );
    snap = new google.maps.LatLng(snap.lat, snap.long);
    let distanceToEnd = google.maps.geometry.spherical.computeDistanceBetween(nearestLine[0], snap);
    let length = google.maps.geometry.spherical.computeDistanceBetween(nearestLine[0], nearestLine[1]);
    return { snap, nearestLine, edge: lineNames[lineIndex], percent: Round(distanceToEnd / length, 3) };
  },

  rightClickPath: function (path, e) {
    if (e.vertex) {
      path.removeAt(e.vertex);
    }
  },

  useMetricChanged: function () {
    for (var connId in this.lineLocations) {
      this.updateConnLabel(connId);
    }
    this.showConnAngles(this.showAnglesOfNode);
  },

  showConnAngles: function (newNodeId, oldNodeId) {
    if (this.pointLocations[oldNodeId] != null) {
      for (var connId in this.pointLocations[oldNodeId].data.n) {
        if (this.lineLocations[connId] && this.shouldShowLabelForConn(connId)) {
          this.updateConnLabel(connId);
        }
      }
    }
    if (this.pointLocations[newNodeId] != null) {
      for (var connId in this.pointLocations[newNodeId].data.n) {
        if (this.lineLocations[connId] && this.shouldShowLabelForConn(connId)) {
          this.updateConnLabel(connId, null, null, this.pointLocations[newNodeId].data.n[connId]);
        }
      }
    }
  },

  updateAllConnLabels: function () {
    for (var connId in this.lineLocations) {
      this.updateConnLabel(connId);
    }
  },

  shouldShowLabelForConn: function (key) {
    return this.showSpanDistances == true || !!this.connsToLabel?.find((x) => x == key);
  },

  updateConnLabel: function (key, length, path, endPointForAngle) {
    this.debounce(
      'update-label-' + key,
      () => {
        let line = this.lineLocations[key];
        if (line) {
          let label = '';
          length = length || this.lineLocations[key].data.d;
          path = path || this.lineLocations[key].getPath();
          // Check if we should show span distances
          if (length && this.shouldShowLabelForConn(key) && !endPointForAngle) {
            if (this.pointLocations[this.showAnglesOfNode]) {
              for (var connId in this.pointLocations[this.showAnglesOfNode].data.n) {
                if (connId == key) {
                  endPointForAngle = this.pointLocations[this.showAnglesOfNode].data.n[connId];
                  break;
                }
              }
            }
          }
          // Add the span length and end point angle
          var p1 = path.getAt(endPointForAngle == 2 ? 1 : 0);
          var p2 = path.getAt(endPointForAngle == 2 ? 0 : 1);
          var heading = google.maps.geometry.spherical.computeHeading(p1, p2);
          var angle = heading + (heading > 0 ? -90 : 90);
          // Check if we should put span distances in the label
          let displayLabel = true;
          if (this.layers[line.jobId] && line.jobId != this.mainJobId) displayLabel = this.layers[line.jobId].label;
          if (this.shouldShowLabelForConn(key) && displayLabel) {
            if (length) {
              if (this.useMetricUnits) {
                label = Round(length * 0.3048, 1) + ' m';
              } else {
                // check if we should round up to the nearest foot
                let l = length;

                if (this.modelConfig) {
                  if (this.modelConfig.round_distances_up == true) {
                    l = Math.ceil(length);
                  }
                }

                label = l + "'";
              }
            }
            if (endPointForAngle != null) {
              label += '\n' + Round((heading + 360) % 360, 1) + '°';
            }
          }
          // Flag for if we should show the names of attributes in the label
          // We should do this if there is more than one attribute displayed
          let showAttributeNames = Object.values(line.labelData || {}).filter((x) => x.value != null).length > 1;
          // Loop through the attributes that should be added to the label
          for (var attribute in line.labelData) {
            for (var itemKey in line.labelData[attribute].value) {
              var value = this.getAttributeLabel(attribute, line.labelData[attribute].value[itemKey]);
              if (value != null && value !== '') {
                if (label != '') label += '\n';
                if (showAttributeNames) label += ToTitleCase(attribute) + ': ';
                label += value;
              }
            }
          }
          if (label.endsWith('\n ')) {
            label = label.slice(0, -2);
          }
          // Get the icon for the label
          let iconData = {
            icon: this.getSVGLabel(label, {
              rotation: angle,
              padding: 2,
              yOffset: -10,
              xAnchor: 'center',
              yAnchor: 'top',
              textAlign: 'center',
              color: 'black',
              backgroundColor: 'rgba(255,255,255,0.6)',
              fontSize: this.labelFontSize ? `${this.labelFontSize}pt` : null
            }),
            position: this.getMidpointLatLng(p1, p2)
          };
          // Set a flag to mark if the line has a label
          const hasLabel = label != '';
          // Check if there is an existing label marker for the line
          if (line.labelMarker == null) {
            // Check if there is a label that we should create a marker
            if (hasLabel) {
              // Create a marker for the line's label
              line.labelMarker = new HybridMarker({
                map: line.getMap(),
                position: iconData.position,
                clickable: false,
                zIndex: line.zIndex || 1,
                icon: iconData.icon
              });
            }
          }
          // If there already is a label marker, then update it
          else {
            Object.assign(line.labelMarker, {
              map: hasLabel ? line.getMap() : null,
              position: iconData.position,
              zIndex: line.zIndex || 1,
              icon: iconData.icon,
              visible: hasLabel
            });
          }
        }
      },
      16
    );
  },

  enableTraceOverlay: function (key, line) {
    if (line.jobId == this.mainJobId) {
      let options = {
        map: line.getMap(),
        clickable: false,
        path: line.getPath(),
        strokeColor: 'red',
        strokeWeight: 18,
        strokeOpacity: 0.2,
        zIndex: -1
      };
      if (this.highlightTrace == key) {
        options.strokeOpacity = 0.5;
        options.strokeColor = 'yellow';
        options.highlight = true;
      }
      line.overlays.trace = new google.maps.Polyline(options);
      line.overlays.trace.ref = FirebaseWorker.ref(
        'photoheight/jobs/' + line.jobId + '/connections/' + key + '/attributes/tracing_complete'
      );
      line.overlays.trace.listener = line.overlays.trace.ref.on('value', (s) => {
        var tracingComplete = s.val();
        var complete = false;
        for (var key in tracingComplete) {
          if (tracingComplete[key]) {
            complete = true;
          }
        }
        line.overlays.trace.doneColor = complete ? '#00FF00' : 'red';
        if (!line.overlays.trace.highlight) {
          line.overlays.trace.setOptions({ strokeColor: line.overlays.trace.doneColor });
        }
      });
    }
  },

  toggleHighlightTraceOverlay: function (newConnId, oldConnId) {
    if (newConnId != this.highlightTrace) {
      this.highlightTrace = newConnId;
      if (oldConnId && this.lineLocations[oldConnId]) {
        let trace = this.lineLocations[oldConnId].overlays.trace;
        if (trace) {
          trace.highlight = false;
          trace.setOptions({ strokeColor: this.lineLocations[oldConnId].overlays.trace.doneColor, strokeOpacity: 0.2 });
        }
      }
      if (newConnId && this.lineLocations[newConnId]) {
        let trace = this.lineLocations[newConnId].overlays.trace;
        if (trace) {
          trace.highlight = true;
          trace.setOptions({ strokeColor: 'yellow', strokeOpacity: 0.5 });
        }
      }
    }
  },

  toggleHighlightTraceOverlayConn: function (newConnId) {
    this.highlightTrace = null;
    if (newConnId && this.lineLocations[newConnId]) {
      let trace = this.lineLocations[newConnId]?.overlays?.trace;
      if (trace) {
        trace.highlight = true;
        trace.setOptions({ strokeColor: 'blue', strokeOpacity: 0.5 });
      }
    }
  },

  getMidpointLatLng: function (latLng1, latLng2) {
    if (!this.projection) {
      this.projection = this.map.getProjection();
    }
    var n1Point = this.projection.fromLatLngToPoint(latLng1);
    var n2Point = this.projection.fromLatLngToPoint(latLng2);
    var midPoint = {
      x: (n1Point.x + n2Point.x) / 2,
      y: (n1Point.y + n2Point.y) / 2
    };
    return this.projection.fromPointToLatLng(midPoint);
  },

  zoomToItemChanged: function () {
    if (this.pointLocations[this.zoomToItem]) {
      this.map.panTo(this.pointLocations[this.zoomToItem].position);
      if (this.map.getZoom() < 18) this.map.setZoom(18);
      this.zoomToItem = null;
    } else if (this.lineLocations[this.zoomToItem]) {
      let connectionBounds = new google.maps.LatLngBounds();
      this.lineLocations[this.zoomToItem].getPath().forEach((x) => {
        connectionBounds.extend(x);
      });
      this.map.fitBounds(connectionBounds);
      if (this.map.getZoom() < 18) this.map.setZoom(18);
      this.zoomToItem = null;
    }
  }
});
